




































import { Prop, Component, Vue } from 'vue-property-decorator'
import { Dress } from '../../types/dresses'
import DressDetails from '../../components/DressComponents/DressDetails.vue'

@Component({
  components: {
    DressDetails
  }
})
export default class DressCard extends Vue {
  @Prop({ default: {} })
  dress!: Dress

  @Prop({ default: false })
  persistent!: Boolean

  private showDressDetails: Boolean = false
}
